import React, { useState, useEffect, createContext, useContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import axios from "axios";
import { API } from "../../../services/api";
import { UserContext } from "../../../App";
import CancleBillDetails from "./create/CancleBillDetails";
axios.defaults.baseURL = API;

const CancleContext = createContext();

function CancelBill() {

  const {userID, LocationID, UserName, LocationName, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);
  const [showData, setShowData] = useState([]);
  const [gTransactionID, setgTransactionID] = useState([]);
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);

  async function HandleCancelBill (TransactionID) {
    if(TransactionID){
      setShow(true);
      setgTransactionID(TransactionID);
    } else{
       setShow(false);
      setgTransactionID();
    }
  }
 

  async function SearchTransaction(e) {
    const { value } = e.target;
    if(value){
      await axios.get(`/SearchTransaction/${value}`).then((response) => {
        let Data = response?.data;
        setShowData(Data);
      }).catch((error) => {
        console.log(error);
      });
    } else {
      setShowData([]);
    }
  };

  const handleclickBack = () => {
      setShowForm(false);
      setshowSubmenu(true);
  };

  return (
    <CancleContext.Provider value={{gTransactionID, userID, LocationID, UserName, LocationName, showForm, setShow, setShowForm, setshowSubmenu, setShowData}}>
      <div className="formContent">
        <CancleBillDetails show={show} onClick={handleClose}/>
        <div className="formCard">
        <div className="Header">
          <div className="title">
              <span>ຍົກເລີກບິນ</span>
          </div>
           <div className="buttonContent">
              <button className="btn btn-danger" onClick={() => handleclickBack()} >Back</button>
          </div>
        </div>
        <div className="Body">
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາເລກບິນ" onChange={(e) => SearchTransaction(e)} />
          </div>
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ເລກບິນ</th>
                <th>ຍອດລວມ</th>
                <th>ສ່ວນຫລຸດ</th>
                <th>ຍອດທີ່ຕ້ອງຈ່າຍ</th>
                <th>ຍອດຈ່າຍ</th>
                <th>ຈ່າຍເພີ່ມ</th>
                <th>ປະເພດຈ່າຍ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.TransactionID}</td>
                        <td >{x.SubTotal}</td>
                        <td >{x.Discount}</td>
                        <td >{x.NetTotal}</td>
                        <td >{x.PaidAmount}</td>
                        <td >{x.PaidMoreAmount}</td>
                        <td >{x.PaymentType}</td>
                        <td >
                          <button className="btn btn-danger" value={x.TransactionID} type="button" onClick={() => HandleCancelBill(x.TransactionID,)}>ຍົກເລີກບິນ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
        </div>
      </div>
      </CancleContext.Provider>
  );
};

export {CancleContext};
export default CancelBill;
